// extracted by mini-css-extract-plugin
module.exports = {"text-intro":"TextIntro_text-intro__vgBQC","description":"TextIntro_description__vUFxC"};